import { render, staticRenderFns } from "./_base-mobile-header.vue?vue&type=template&id=2eaa8d6a"
import script from "./_base-mobile-header.vue?vue&type=script&lang=js"
export * from "./_base-mobile-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports